/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  CSSProperties,
  RefObject,
  useEffect,
  useRef,
  useState,
} from "react"

/**
 * テキスト入力用のラッパー
 * @param {ReactPropTypes} { name:項目の論理名(string), value:設定対象のstate(string), setValue:設定対象のstateに対するsetState(function), id:comtrolのID(string), required:必須チェックを行うか(boolean) }
 * @return {ReactComponentElement}
 */
const TextAreaInput: React.FC<{
  value: string
  setValue: (value: string) => void
  onKeyDown?: React.KeyboardEventHandler<HTMLTextAreaElement>
  style?: CSSProperties
  autoFocus?: boolean
  name?: string
  id?: string
  cols?: number
  rows?: number
  maxLength?: number
  tabIndex?: number
  className?: string
  isReadOnly?: boolean
  isRequired?: boolean
  isDisabled?: boolean
  placeholder?: string
  type?: "text" | "email" | "tel" | "number" | "password"
  pattern?: string
  setInvalidMessage?: (value: string) => void
  autoComplete?: "off" | "nope"
  ref?: RefObject<HTMLTextAreaElement>
}> = ({
  onKeyDown,
  style,
  autoFocus,
  name,
  value,
  setValue,
  id,
  cols,
  rows,
  maxLength,
  tabIndex,
  isReadOnly: readOnly,
  isRequired: required,
  isDisabled: disabled,
  placeholder,
  type = "text",
  setInvalidMessage,
  autoComplete,
  ref,
  className,
}) => {
  const parentRef = useRef(null)
  const [isError, setIsError] = useState<boolean>(false)

  const setErrorMessage = (message: string) => {
    //エラーメッセージを返す
    if (setInvalidMessage ?? false) {
      setInvalidMessage!(message)
    }
  }

  function inValid(e: React.FocusEvent<HTMLTextAreaElement>) {
    let message = ""
    let isErrorInner = false
    if (e.target.validity.valueMissing) {
      isErrorInner = true
      message = `${name}は必須入力です。`
    } else if (e.target.validity.patternMismatch) {
      isErrorInner = true
      message = `${name}の入力形式を確認してください。`
    } else if (e.target.validity.tooLong) {
      isErrorInner = true
      message = `${name}の値が大きすぎます。`
    } else if (e.target.validity.tooShort) {
      isErrorInner = true
      message = `${name}の値が小さすぎます。`
    } else if (type === "email" && e.target.validity.typeMismatch) {
      isErrorInner = true
      message = `${name}をxxx@yyyyの形式に合わせて入力してください`
    }

    setErrorMessage(message)
    setIsError(isErrorInner)
  }

  const innerRef = React.createRef<HTMLTextAreaElement>()

  useEffect(() => {
    if (autoFocus) {
      if (ref) {
        ref.current?.focus()
      } else {
        innerRef.current?.focus()
      }
    }
  }, [])

  return (
    <>
      <div
        className={["wj-control", "wj-content", "wj-dropdown", className].join(
          " "
        )}
        ref={parentRef}>
        <div className="wj-template">
          <div className="wj-input">
            <div className="wj-input-group">
              <textarea
                onKeyDown={onKeyDown}
                style={style}
                autoFocus={autoFocus}
                ref={ref ?? innerRef}
                id={id}
                className={[
                  "wj-form-control",
                  "wj-form-content",
                  "text-input",
                  isError ? "is-error" : "",
                  readOnly ? "read-only" : "",
                ].join(" ")}
                value={value}
                readOnly={readOnly}
                required={required}
                disabled={disabled}
                cols={cols}
                rows={rows}
                maxLength={
                  maxLength ? maxLength : type === "tel" ? 13 : undefined
                }
                tabIndex={tabIndex}
                placeholder={placeholder}
                autoComplete={autoComplete ?? "nope"}
                onChange={(e) => {
                  setValue(e.target.value)
                  setErrorMessage("")
                  e.currentTarget.checkValidity()
                }}
                onInvalid={(e: React.FocusEvent<HTMLTextAreaElement>) =>
                  inValid(e)
                }
              />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default TextAreaInput
